import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

// import awsExports from 'aws-exports';
// import { Amplify } from 'aws-amplify';

// import { getCurrentUser, fetchDevices } from 'aws-amplify/auth';


// Amplify.configure(awsExports);



root.render(<App />);
